import React from "react";

const Menu = ({ children, closeMenu }) => {
  return (
    <nav id="menu" onClick={closeMenu}>
      <div className="inner">
        <h2>Menu</h2>
        <ul className="links">
          {React.Children.map(children, link => (
            <li onClick={closeMenu}>{link}</li>
          ))}
        </ul>
        <a href="#close-menu" className="close" onClick={closeMenu} />
      </div>
    </nav>
  );
};

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Menu.js